import { call, takeLatest, put } from 'redux-saga/effects';
import { getProfilesAPI } from '../../services/profiles';
import { getProfiles, setSelectProfile } from './actions';
import { LOGIN_SUCCESS, UPDATE_PROFILES } from './actionTypes';

function* fetchProfiles() {
  const profiles = yield call(getProfilesAPI);
  yield put(getProfiles(profiles.data));
}

const SELECT_PROFILE = 'profile';

function* updateProfiles() {
  const profiles = yield call(getProfilesAPI);
  const mainProfile = profiles?.data.find((profile) => profile.isMainProfile);
  const selectedProfile = JSON.parse(localStorage.getItem(SELECT_PROFILE));
  const isValidProfile = profiles?.data.some((profile) => profile.id === selectedProfile?.id);

  localStorage.setItem('profiles', JSON.stringify(profiles.data));
  yield put(getProfiles(profiles.data));

  if (selectedProfile && isValidProfile) {
    localStorage.setItem(SELECT_PROFILE, JSON.stringify(selectedProfile));
    yield put(setSelectProfile(selectedProfile));
  } else if (mainProfile) {
    localStorage.setItem(SELECT_PROFILE, JSON.stringify(mainProfile));
    yield put(setSelectProfile(mainProfile));
  }
}

export default function* profilesSaga() {
  yield takeLatest(LOGIN_SUCCESS, fetchProfiles);
  yield takeLatest(UPDATE_PROFILES, updateProfiles);
}
